import { render, staticRenderFns } from "./project-base-info.vue?vue&type=template&id=0e5baf44&"
import script from "./project-base-info.vue?vue&type=script&lang=js&"
export * from "./project-base-info.vue?vue&type=script&lang=js&"
import style0 from "./project-base-info.vue?vue&type=style&index=0&id=0e5baf44&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports